export const STOCK_LEVEL = {
    GOOD: "GOOD",
} as const;

export const AFTERPAY_MODAL_HOST = "https://static.afterpay.com/lightbox-desktop@3x.png";
export const CLEARPAY_MODAL_HOST = "https://static.afterpay.com/clearpay-lightbox-desktop@2x.png";

export type STOCK_LEVEL = typeof STOCK_LEVEL[keyof typeof STOCK_LEVEL];

// ?af_qr=true
export const localeToGiftCardLink = {
    "en-AU": "https://afterpayau.onelink.me/nz1F/si2wrtae",
    "en-GB": "https://clearpay.onelink.me/ah1q/mykiacbz",
    "en-NZ": "https://afterpayau.onelink.me/nz1F/23utlm1o",
    "en-US": "https://afterpayus.onelink.me/Ff2R/rss773uh",
    "en-CA": "https://afterpayus.onelink.me/Ff2R/av4qdj96",
    "fr-CA": "https://afterpayus.onelink.me/Ff2R/av4qdj96",
};
